import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { CameraCapture } from "@/components/CameraCapture";
import { api, errMsg } from "@/lib/api";

const CFG = {
  start: { title: "Inizia il lavoro", kind: "FOTO PRIMA", desc: "Scatta la foto della situazione prima dell'intervento." },
  complete: { title: "Dichiara completato", kind: "FOTO DOPO", desc: "Scatta la foto del lavoro finito. Passerà al responsabile per la verifica." },
};

export const PhotoActionDialog = ({ order, action, onClose, onDone }) => {
  const cfg = CFG[action];
  const [blob, setBlob] = useState(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("action", action);
      fd.append("note", note);
      fd.append("file", blob, `${action}.jpg`);
      const { data } = await api.post(`/orders/${order.id}/photo-action`, fd);
      toast.success(`${cfg.title}: registrato con ${cfg.kind.toLowerCase()}`);
      onDone(data);
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="max-h-[94vh] max-w-lg overflow-y-auto rounded-2xl" data-testid={`photo-action-dialog-${action}`}>
        <DialogHeader>
          <DialogTitle className="text-xl font-extrabold">{cfg.title} · {cfg.kind}</DialogTitle>
          <DialogDescription>{order.code} · {cfg.desc} Data, ora e codice vengono impressi sulla foto dal server.</DialogDescription>
        </DialogHeader>
        <CameraCapture onCapture={setBlob} />
        {action === "complete" && <Textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} placeholder="Nota (facoltativa)" data-testid="photo-action-note" />}
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={busy} className="rounded-xl">Annulla</Button>
          <Button onClick={submit} disabled={!blob || busy} className="rounded-xl font-bold" data-testid="photo-action-confirm">{busy ? "Invio…" : "Conferma con la foto"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
